// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}



.Homespeeches_speeches__9tHHU {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 80px;
}

.Homespeeches_container__Pll9Y {
    display: flex;
    width: 100%;
    max-width: 1200px;
    gap: 20px;
}

.Homespeeches_right__WseRN {
    flex: 0.4 1;
    min-width: 0;
    position: relative;
}

.Homespeeches_left__6pOXh {
    flex: 0.6 1;
    min-width: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.Homespeeches_content__HKG1Q,
.Homespeeches_subcontent__\\+DD45 {
    position: relative;
    cursor: pointer;
}

.Homespeeches_subcontent__\\+DD45 {
    height: 130px;
    width: 180px;
    flex-shrink: 0;
}

.Homespeeches_cover__u\\+DU3 {
    width: 100%;
    /* height: 299px; */
    height: 299px;
    display: block;
    border-radius: 16px;
    object-fit: cover;
    /* object-position: center;  */
    object-position: top; 
}

.Homespeeches_playicon__PwsZv {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
}

.Homespeeches_playicon__PwsZv img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Homespeeches_text__2AF4T {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;  
}

.Homespeeches_text__2AF4T h3 {
    margin: 0 0 8px 0; 
    font-size: 16px;
    line-height: 1.4;
    color: #333;
}

.Homespeeches_text__2AF4T .Homespeeches_link__IUYWy {
    text-align: left;
    margin-top: auto; 
}

.Homespeeches_text__2AF4T .Homespeeches_para__HPKGq {
    font-size: 14px;
    color: #0000009c;
    line-height: 1.5;
    font-weight: 500;
    margin: 8px 0 15px 0;
    text-align: justify;
    flex: 1 1;
}

.Homespeeches_link__IUYWy span a {
    text-decoration: none;
    color: #02301c;
    padding: 3px 0px;
    border-bottom: 3px solid #015933;
    font-weight: 600;
    font-size: 11px;
}

.Homespeeches_subproduct__HT3Sh {
    width: 100%;
    height: 130px; 
    position: relative;
    display: flex;
    gap: 15px;
    align-items: stretch; 
    margin-bottom: 20px;
}

.Homespeeches_subproduct__HT3Sh .Homespeeches_text__2AF4T {
    display: flex;
    flex-direction: column;
    justify-content: space-between; 
    height: 130px; 
    padding: 0; 
}

.Homespeeches_subplayicon__sMa5B {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    z-index: 10;
}

.Homespeeches_subplayicon__sMa5B img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Homespeeches_subcover__zG8Qt {
    width: 180px;
    height: 130px; 
    border-radius: 16px;
    object-fit: cover;
    flex-shrink: 0;
}

.Homespeeches_subtitle__zAUDy {
    margin: 0; 
    font-size: 14px;
    line-height: 1.3;
    color: #333;
    padding: 0;
}

.Homespeeches_subpara__9j2mY {
    font-size: 13px !important;
    color: #0000009c;
    line-height: 1.4;
    font-weight: 500;
    margin: 5px 0 0 0; 
    text-align: justify;
    flex: 1 1; 
    overflow: hidden; 
}

.Homespeeches_subproduct__HT3Sh .Homespeeches_link__IUYWy {
    margin-top: 0; 
    align-self: flex-end; 
}

/* Responsive */
@media (max-width: 1300px) {
    .Homespeeches_container__Pll9Y {
        flex-direction: column;
        gap: 30px;
    }
    
    .Homespeeches_right__WseRN, .Homespeeches_left__6pOXh {
        flex: none;
        width: 100%;
    }
}

/* Large tablets */
@media (max-width: 1024px) {
    .Homespeeches_speeches__9tHHU {
        padding: 15px;
        margin-bottom: 60px;
    }
    
    .Homespeeches_container__Pll9Y {
        gap: 25px;
    }
    
    .Homespeeches_subproduct__HT3Sh {
        gap: 12px;
        margin-bottom: 25px;
        height: 120px;  
    }
    
    .Homespeeches_subproduct__HT3Sh .Homespeeches_text__2AF4T {
        height: 120px;
    }
    
    .Homespeeches_subcontent__\\+DD45 {
        width: 160px;
        height: 120px;
    }
    
    .Homespeeches_subcover__zG8Qt {
        width: 160px;
        height: 120px;
    }
    
    .Homespeeches_subtitle__zAUDy {
        font-size: 13px;
    }
    
    .Homespeeches_subpara__9j2mY {
        font-size: 12px !important;
    }
}

/* Medium tablets */
@media (max-width: 900px) {
    .Homespeeches_subproduct__HT3Sh {
        height: 110px;
    }
    
    .Homespeeches_subproduct__HT3Sh .Homespeeches_text__2AF4T {
        height: 110px;
    }
    
    .Homespeeches_subcontent__\\+DD45 {
        width: 150px;
        height: 110px;
    }
    
    .Homespeeches_subcover__zG8Qt {
        width: 150px;
        height: 110px;
    }
    
    .Homespeeches_subtitle__zAUDy {
        font-size: 12px;
        line-height: 1.2;
    }
    
    .Homespeeches_subpara__9j2mY {
        font-size: 11px !important;
        line-height: 1.3;
    }
}

@media (max-width: 768px) {
    .Homespeeches_speeches__9tHHU {
        padding: 15px 10px;
        margin-bottom: 100px;
    }
    
    .Homespeeches_container__Pll9Y {
        flex-direction: column;
        gap: 30px;
        max-width: 100%;
    }
    
    .Homespeeches_right__WseRN, .Homespeeches_left__6pOXh {
        width: 100%;
    }
    
    .Homespeeches_cover__u\\+DU3 {
        height: 250px;
    }
    
    .Homespeeches_text__2AF4T h3 {
        font-size: 18px;
        margin: 15px 0 10px 0;
    }
    
    .Homespeeches_text__2AF4T .Homespeeches_para__HPKGq {
        font-size: 14px;
        margin: 10px 0 20px 0;
    }
    
    /* Switch to column layout for mobile */
    .Homespeeches_subproduct__HT3Sh {
        flex-direction: column;
        gap: 15px;
        margin-bottom: 30px;
        height: auto; 
        align-items: center;
    }
    
    .Homespeeches_subproduct__HT3Sh .Homespeeches_text__2AF4T {
        height: auto;
        justify-content: flex-start;
    }
    
    .Homespeeches_subcontent__\\+DD45 {
        width: 100%;
        height: 200px;
        max-width: 300px;
    }
    
    .Homespeeches_subcover__zG8Qt {
        width: 100%;
        height: 180px;
        max-width: 300px;
    }
    
    .Homespeeches_subtitle__zAUDy {
        font-size: 16px;
        margin: 10px 0 8px 0;
        text-align: center;
    }
    
    .Homespeeches_subpara__9j2mY {
        font-size: 14px !important;
        text-align: justify;
        margin: 8px 0 15px 0;
    }
    
    .Homespeeches_text__2AF4T .Homespeeches_link__IUYWy {
        text-align: center;
        margin-top: 20px;
    }
}

/* Mobile phones */
@media (max-width: 480px) {
    .Homespeeches_speeches__9tHHU {
        padding: 10px 5px;
        margin-bottom: 120px;
    }
    
    .Homespeeches_container__Pll9Y {
        gap: 25px;
    }
    
    .Homespeeches_cover__u\\+DU3 {
        height: 200px;
        border-radius: 12px;
    }
    
    .Homespeeches_playicon__PwsZv {
        width: 50px;
        height: 50px;
    }
    
    .Homespeeches_text__2AF4T h3 {
        font-size: 16px;
        margin: 12px 0 8px 0;
        line-height: 1.3;
    }
    
    .Homespeeches_text__2AF4T .Homespeeches_para__HPKGq {
        font-size: 13px;
        line-height: 1.4;
        margin: 8px 0 15px 0;
    }
    
    .Homespeeches_subproduct__HT3Sh {
        margin-bottom: 25px;
        gap: 12px;
    }
    
    .Homespeeches_subcontent__\\+DD45 {
        height: 150px;
        max-width: 250px;
    }
    
    .Homespeeches_subcover__zG8Qt {
        height: 130px;
        max-width: 250px;
        border-radius: 12px;
    }
    
    .Homespeeches_subplayicon__sMa5B {
        width: 25px;
        height: 25px;
    }
    
    .Homespeeches_subtitle__zAUDy {
        font-size: 14px;
        margin: 8px 0 6px 0;
        line-height: 1.2;
    }
    
    .Homespeeches_subpara__9j2mY {
        font-size: 12px !important;
        line-height: 1.3;
        margin: 6px 0 12px 0;
    }
    
    .Homespeeches_link__IUYWy span a {
        font-size: 10px;
        padding: 2px 0;
        border-bottom: 2px solid #015933;
    }
}

/* Very small phones */
@media (max-width: 360px) {
    .Homespeeches_speeches__9tHHU {
        padding: 8px 3px;
        margin-bottom: 150px;
    }
    
    .Homespeeches_container__Pll9Y {
        gap: 20px;
    }
    
    .Homespeeches_cover__u\\+DU3 {
        height: 180px;
        border-radius: 10px;
    }
    
    .Homespeeches_playicon__PwsZv {
        width: 40px;
        height: 40px;
    }
    
    .Homespeeches_text__2AF4T h3 {
        font-size: 15px;
        margin: 10px 0 6px 0;
    }
    
    .Homespeeches_text__2AF4T .Homespeeches_para__HPKGq {
        font-size: 12px;
        margin: 6px 0 12px 0;
    }
    
    .Homespeeches_subproduct__HT3Sh {
        margin-bottom: 20px;
        gap: 10px;
    }
    
    .Homespeeches_subcontent__\\+DD45 {
        height: 120px;
        max-width: 200px;
    }
    
    .Homespeeches_subcover__zG8Qt {
        height: 100px;
        max-width: 200px;
        border-radius: 10px;
    }
    
    .Homespeeches_subplayicon__sMa5B {
        width: 20px;
        height: 20px;
    }
    
    .Homespeeches_subtitle__zAUDy {
        font-size: 13px;
        margin: 6px 0 4px 0;
    }
    
    .Homespeeches_subpara__9j2mY {
        font-size: 11px !important;
        line-height: 1.2;
        margin: 4px 0 10px 0;
    }
    
    .Homespeeches_link__IUYWy span a {
        font-size: 9px;
        padding: 1px 0;
        border-bottom: 1px solid #015933;
    }
}

@media (min-width: 576px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-sm__vhoBi {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-md__9sraN {
        max-width: 720px;
    }
}

@media (min-width: 992px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-lg__8SuR- {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-xl__A0Rbt {
        max-width: 1100px;
    }
}

@media (min-width: 1400px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-xxl__Dc4UL {
        max-width: 1220px;
    }
}

@media (min-width: 1600px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-xxxl__SulVj {
        max-width: 1400px;
    }
}

@media (min-width: 1920px) {
    .Homespeeches_container__Pll9Y, .Homespeeches_container-4k__1yrkn {
        max-width: 1550px;
    }
}

.Homespeeches_speeches__9tHHU.Homespeeches_section-before-footer__\\+VY-s {
    margin-bottom: 180px !important;
}

@media (max-width: 768px) {
    .Homespeeches_speeches__9tHHU.Homespeeches_section-before-footer__\\+VY-s {
        margin-bottom: 220px !important;
    }
}

@media (max-width: 480px) {
    .Homespeeches_speeches__9tHHU.Homespeeches_section-before-footer__\\+VY-s {
        margin-bottom: 280px !important;
    }
}

.Homespeeches_stateBox__e1OVJ {
    width: 100%;
    min-height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin: 20px auto 80px;
    padding: 24px;
    border-radius: 18px;
    background: linear-gradient(135deg, #f8fcfa 0%, #edf8f2 100%);
    border: 1px solid rgba(1, 89, 51, 0.12);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

.Homespeeches_stateText__HJLa9 {
    font-size: 15px;
    font-weight: 600;
    color: #02301c;
    text-align: center;
    margin: 0;
}

.Homespeeches_loader__dn5Yl {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 4px solid rgba(1, 89, 51, 0.12);
    border-top-color: #015933;
    animation: Homespeeches_spin__o60IM 0.9s linear infinite;
}

@keyframes Homespeeches_spin__o60IM {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .Homespeeches_stateBox__e1OVJ {
        min-height: 220px;
        margin-bottom: 60px;
        padding: 20px;
    }

    .Homespeeches_stateText__HJLa9 {
        font-size: 14px;
    }

    .Homespeeches_loader__dn5Yl {
        width: 40px;
        height: 40px;
        border-width: 3px;
    }
}

@media (max-width: 480px) {
    .Homespeeches_stateBox__e1OVJ {
        min-height: 180px;
        margin-bottom: 50px;
        padding: 18px;
        border-radius: 14px;
    }

    .Homespeeches_stateText__HJLa9 {
        font-size: 13px;
    }

    .Homespeeches_loader__dn5Yl {
        width: 34px;
        height: 34px;
        border-width: 3px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/website/Home/Homespeeches.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;QACT,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,qBAAqB;IACzB;;IAEA,uCAAuC;IACvC;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gCAAgC;IACpC;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,6DAA6D;IAC7D,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,yBAAyB;IACzB,wDAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n\r\n\r\n.speeches {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n    margin-bottom: 80px;\r\n}\r\n\r\n.container {\r\n    display: flex;\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    gap: 20px;\r\n}\r\n\r\n.right {\r\n    flex: 0.4;\r\n    min-width: 0;\r\n    position: relative;\r\n}\r\n\r\n.left {\r\n    flex: 0.6;\r\n    min-width: 0;\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.content,\r\n.subcontent {\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.subcontent {\r\n    height: 130px;\r\n    width: 180px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.cover {\r\n    width: 100%;\r\n    /* height: 299px; */\r\n    height: 299px;\r\n    display: block;\r\n    border-radius: 16px;\r\n    object-fit: cover;\r\n    /* object-position: center;  */\r\n    object-position: top; \r\n}\r\n\r\n.playicon {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n.playicon img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.text {\r\n    flex: 1;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;  \r\n}\r\n\r\n.text h3 {\r\n    margin: 0 0 8px 0; \r\n    font-size: 16px;\r\n    line-height: 1.4;\r\n    color: #333;\r\n}\r\n\r\n.text .link {\r\n    text-align: left;\r\n    margin-top: auto; \r\n}\r\n\r\n.text .para {\r\n    font-size: 14px;\r\n    color: #0000009c;\r\n    line-height: 1.5;\r\n    font-weight: 500;\r\n    margin: 8px 0 15px 0;\r\n    text-align: justify;\r\n    flex: 1;\r\n}\r\n\r\n.link span a {\r\n    text-decoration: none;\r\n    color: #02301c;\r\n    padding: 3px 0px;\r\n    border-bottom: 3px solid #015933;\r\n    font-weight: 600;\r\n    font-size: 11px;\r\n}\r\n\r\n.subproduct {\r\n    width: 100%;\r\n    height: 130px; \r\n    position: relative;\r\n    display: flex;\r\n    gap: 15px;\r\n    align-items: stretch; \r\n    margin-bottom: 20px;\r\n}\r\n\r\n.subproduct .text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between; \r\n    height: 130px; \r\n    padding: 0; \r\n}\r\n\r\n.subplayicon {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 30px;\r\n    height: 30px;\r\n    z-index: 10;\r\n}\r\n\r\n.subplayicon img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.subcover {\r\n    width: 180px;\r\n    height: 130px; \r\n    border-radius: 16px;\r\n    object-fit: cover;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.subtitle {\r\n    margin: 0; \r\n    font-size: 14px;\r\n    line-height: 1.3;\r\n    color: #333;\r\n    padding: 0;\r\n}\r\n\r\n.subpara {\r\n    font-size: 13px !important;\r\n    color: #0000009c;\r\n    line-height: 1.4;\r\n    font-weight: 500;\r\n    margin: 5px 0 0 0; \r\n    text-align: justify;\r\n    flex: 1; \r\n    overflow: hidden; \r\n}\r\n\r\n.subproduct .link {\r\n    margin-top: 0; \r\n    align-self: flex-end; \r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 1300px) {\r\n    .container {\r\n        flex-direction: column;\r\n        gap: 30px;\r\n    }\r\n    \r\n    .right, .left {\r\n        flex: none;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n/* Large tablets */\r\n@media (max-width: 1024px) {\r\n    .speeches {\r\n        padding: 15px;\r\n        margin-bottom: 60px;\r\n    }\r\n    \r\n    .container {\r\n        gap: 25px;\r\n    }\r\n    \r\n    .subproduct {\r\n        gap: 12px;\r\n        margin-bottom: 25px;\r\n        height: 120px;  \r\n    }\r\n    \r\n    .subproduct .text {\r\n        height: 120px;\r\n    }\r\n    \r\n    .subcontent {\r\n        width: 160px;\r\n        height: 120px;\r\n    }\r\n    \r\n    .subcover {\r\n        width: 160px;\r\n        height: 120px;\r\n    }\r\n    \r\n    .subtitle {\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .subpara {\r\n        font-size: 12px !important;\r\n    }\r\n}\r\n\r\n/* Medium tablets */\r\n@media (max-width: 900px) {\r\n    .subproduct {\r\n        height: 110px;\r\n    }\r\n    \r\n    .subproduct .text {\r\n        height: 110px;\r\n    }\r\n    \r\n    .subcontent {\r\n        width: 150px;\r\n        height: 110px;\r\n    }\r\n    \r\n    .subcover {\r\n        width: 150px;\r\n        height: 110px;\r\n    }\r\n    \r\n    .subtitle {\r\n        font-size: 12px;\r\n        line-height: 1.2;\r\n    }\r\n    \r\n    .subpara {\r\n        font-size: 11px !important;\r\n        line-height: 1.3;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .speeches {\r\n        padding: 15px 10px;\r\n        margin-bottom: 100px;\r\n    }\r\n    \r\n    .container {\r\n        flex-direction: column;\r\n        gap: 30px;\r\n        max-width: 100%;\r\n    }\r\n    \r\n    .right, .left {\r\n        width: 100%;\r\n    }\r\n    \r\n    .cover {\r\n        height: 250px;\r\n    }\r\n    \r\n    .text h3 {\r\n        font-size: 18px;\r\n        margin: 15px 0 10px 0;\r\n    }\r\n    \r\n    .text .para {\r\n        font-size: 14px;\r\n        margin: 10px 0 20px 0;\r\n    }\r\n    \r\n    /* Switch to column layout for mobile */\r\n    .subproduct {\r\n        flex-direction: column;\r\n        gap: 15px;\r\n        margin-bottom: 30px;\r\n        height: auto; \r\n        align-items: center;\r\n    }\r\n    \r\n    .subproduct .text {\r\n        height: auto;\r\n        justify-content: flex-start;\r\n    }\r\n    \r\n    .subcontent {\r\n        width: 100%;\r\n        height: 200px;\r\n        max-width: 300px;\r\n    }\r\n    \r\n    .subcover {\r\n        width: 100%;\r\n        height: 180px;\r\n        max-width: 300px;\r\n    }\r\n    \r\n    .subtitle {\r\n        font-size: 16px;\r\n        margin: 10px 0 8px 0;\r\n        text-align: center;\r\n    }\r\n    \r\n    .subpara {\r\n        font-size: 14px !important;\r\n        text-align: justify;\r\n        margin: 8px 0 15px 0;\r\n    }\r\n    \r\n    .text .link {\r\n        text-align: center;\r\n        margin-top: 20px;\r\n    }\r\n}\r\n\r\n/* Mobile phones */\r\n@media (max-width: 480px) {\r\n    .speeches {\r\n        padding: 10px 5px;\r\n        margin-bottom: 120px;\r\n    }\r\n    \r\n    .container {\r\n        gap: 25px;\r\n    }\r\n    \r\n    .cover {\r\n        height: 200px;\r\n        border-radius: 12px;\r\n    }\r\n    \r\n    .playicon {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n    \r\n    .text h3 {\r\n        font-size: 16px;\r\n        margin: 12px 0 8px 0;\r\n        line-height: 1.3;\r\n    }\r\n    \r\n    .text .para {\r\n        font-size: 13px;\r\n        line-height: 1.4;\r\n        margin: 8px 0 15px 0;\r\n    }\r\n    \r\n    .subproduct {\r\n        margin-bottom: 25px;\r\n        gap: 12px;\r\n    }\r\n    \r\n    .subcontent {\r\n        height: 150px;\r\n        max-width: 250px;\r\n    }\r\n    \r\n    .subcover {\r\n        height: 130px;\r\n        max-width: 250px;\r\n        border-radius: 12px;\r\n    }\r\n    \r\n    .subplayicon {\r\n        width: 25px;\r\n        height: 25px;\r\n    }\r\n    \r\n    .subtitle {\r\n        font-size: 14px;\r\n        margin: 8px 0 6px 0;\r\n        line-height: 1.2;\r\n    }\r\n    \r\n    .subpara {\r\n        font-size: 12px !important;\r\n        line-height: 1.3;\r\n        margin: 6px 0 12px 0;\r\n    }\r\n    \r\n    .link span a {\r\n        font-size: 10px;\r\n        padding: 2px 0;\r\n        border-bottom: 2px solid #015933;\r\n    }\r\n}\r\n\r\n/* Very small phones */\r\n@media (max-width: 360px) {\r\n    .speeches {\r\n        padding: 8px 3px;\r\n        margin-bottom: 150px;\r\n    }\r\n    \r\n    .container {\r\n        gap: 20px;\r\n    }\r\n    \r\n    .cover {\r\n        height: 180px;\r\n        border-radius: 10px;\r\n    }\r\n    \r\n    .playicon {\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n    \r\n    .text h3 {\r\n        font-size: 15px;\r\n        margin: 10px 0 6px 0;\r\n    }\r\n    \r\n    .text .para {\r\n        font-size: 12px;\r\n        margin: 6px 0 12px 0;\r\n    }\r\n    \r\n    .subproduct {\r\n        margin-bottom: 20px;\r\n        gap: 10px;\r\n    }\r\n    \r\n    .subcontent {\r\n        height: 120px;\r\n        max-width: 200px;\r\n    }\r\n    \r\n    .subcover {\r\n        height: 100px;\r\n        max-width: 200px;\r\n        border-radius: 10px;\r\n    }\r\n    \r\n    .subplayicon {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n    \r\n    .subtitle {\r\n        font-size: 13px;\r\n        margin: 6px 0 4px 0;\r\n    }\r\n    \r\n    .subpara {\r\n        font-size: 11px !important;\r\n        line-height: 1.2;\r\n        margin: 4px 0 10px 0;\r\n    }\r\n    \r\n    .link span a {\r\n        font-size: 9px;\r\n        padding: 1px 0;\r\n        border-bottom: 1px solid #015933;\r\n    }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .container, .container-sm {\r\n        max-width: 540px;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .container, .container-md {\r\n        max-width: 720px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .container, .container-lg {\r\n        max-width: 960px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container, .container-xl {\r\n        max-width: 1100px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container, .container-xxl {\r\n        max-width: 1220px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container, .container-xxxl {\r\n        max-width: 1400px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .container, .container-4k {\r\n        max-width: 1550px;\r\n    }\r\n}\r\n\r\n.speeches.section-before-footer {\r\n    margin-bottom: 180px !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 220px !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 280px !important;\r\n    }\r\n}\r\n\r\n.stateBox {\r\n    width: 100%;\r\n    min-height: 260px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 16px;\r\n    margin: 20px auto 80px;\r\n    padding: 24px;\r\n    border-radius: 18px;\r\n    background: linear-gradient(135deg, #f8fcfa 0%, #edf8f2 100%);\r\n    border: 1px solid rgba(1, 89, 51, 0.12);\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.stateText {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    color: #02301c;\r\n    text-align: center;\r\n    margin: 0;\r\n}\r\n\r\n.loader {\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 50%;\r\n    border: 4px solid rgba(1, 89, 51, 0.12);\r\n    border-top-color: #015933;\r\n    animation: spin 0.9s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .stateBox {\r\n        min-height: 220px;\r\n        margin-bottom: 60px;\r\n        padding: 20px;\r\n    }\r\n\r\n    .stateText {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .loader {\r\n        width: 40px;\r\n        height: 40px;\r\n        border-width: 3px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .stateBox {\r\n        min-height: 180px;\r\n        margin-bottom: 50px;\r\n        padding: 18px;\r\n        border-radius: 14px;\r\n    }\r\n\r\n    .stateText {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .loader {\r\n        width: 34px;\r\n        height: 34px;\r\n        border-width: 3px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"speeches": `Homespeeches_speeches__9tHHU`,
	"container": `Homespeeches_container__Pll9Y`,
	"right": `Homespeeches_right__WseRN`,
	"left": `Homespeeches_left__6pOXh`,
	"content": `Homespeeches_content__HKG1Q`,
	"subcontent": `Homespeeches_subcontent__+DD45`,
	"cover": `Homespeeches_cover__u+DU3`,
	"playicon": `Homespeeches_playicon__PwsZv`,
	"text": `Homespeeches_text__2AF4T`,
	"link": `Homespeeches_link__IUYWy`,
	"para": `Homespeeches_para__HPKGq`,
	"subproduct": `Homespeeches_subproduct__HT3Sh`,
	"subplayicon": `Homespeeches_subplayicon__sMa5B`,
	"subcover": `Homespeeches_subcover__zG8Qt`,
	"subtitle": `Homespeeches_subtitle__zAUDy`,
	"subpara": `Homespeeches_subpara__9j2mY`,
	"container-sm": `Homespeeches_container-sm__vhoBi`,
	"container-md": `Homespeeches_container-md__9sraN`,
	"container-lg": `Homespeeches_container-lg__8SuR-`,
	"container-xl": `Homespeeches_container-xl__A0Rbt`,
	"container-xxl": `Homespeeches_container-xxl__Dc4UL`,
	"container-xxxl": `Homespeeches_container-xxxl__SulVj`,
	"container-4k": `Homespeeches_container-4k__1yrkn`,
	"section-before-footer": `Homespeeches_section-before-footer__+VY-s`,
	"stateBox": `Homespeeches_stateBox__e1OVJ`,
	"stateText": `Homespeeches_stateText__HJLa9`,
	"loader": `Homespeeches_loader__dn5Yl`,
	"spin": `Homespeeches_spin__o60IM`
};
export default ___CSS_LOADER_EXPORT___;
